import { useEffect, useState } from 'react';

import { DropdownOptionType } from '../types/dropdown';
import { UseAndCareVideosModel } from '../interface/support-and-service';
import { DROPDOWN_DEFAULT_VALUE } from '../constants/dropdown';
import { isFalseAll, isOneConditionTrue, isTrueAll } from '../utils/conditions';

export const useUseAndCareVideosFilter = (
  categoryDropdownOptions: DropdownOptionType[],
  useAndCareVideosData: UseAndCareVideosModel[]
) => {
  const [brandFilter, setBrandFilter] = useState<string>(
    DROPDOWN_DEFAULT_VALUE
  );
  const [categoryFilter, setCategoryFilter] = useState<string>(
    DROPDOWN_DEFAULT_VALUE
  );
  const [filteredUseAndCareVideos, setFilteredUseAndCareVideos] =
    useState(useAndCareVideosData);

  const setDropdownCategoryOptions = categoryDropdownOptions.filter(
    (category) => [category.brand, DROPDOWN_DEFAULT_VALUE].includes(brandFilter)
  );

  const filteredDropdownOptions =
    brandFilter === DROPDOWN_DEFAULT_VALUE
      ? categoryDropdownOptions
      : [categoryDropdownOptions[0], ...setDropdownCategoryOptions];

  useEffect(() => {
    if (brandFilter !== DROPDOWN_DEFAULT_VALUE)
      setCategoryFilter(filteredDropdownOptions[0].optionValue);
  }, [brandFilter]);

  useEffect(() => {
    if (isTrueAll([brandFilter, categoryFilter], DROPDOWN_DEFAULT_VALUE))
      setFilteredUseAndCareVideos(useAndCareVideosData);
    if (isOneConditionTrue(brandFilter, categoryFilter, DROPDOWN_DEFAULT_VALUE))
      setFilteredUseAndCareVideos(
        useAndCareVideosData.filter(
          (useAndCareVideo: UseAndCareVideosModel) =>
            useAndCareVideo.attributes.brand === brandFilter
        )
      );
    if (isOneConditionTrue(categoryFilter, brandFilter, DROPDOWN_DEFAULT_VALUE))
      setFilteredUseAndCareVideos(
        useAndCareVideosData.filter(
          (useAndCareVideo: UseAndCareVideosModel) =>
            useAndCareVideo.attributes.category === categoryFilter
        )
      );
    if (isFalseAll([brandFilter, categoryFilter], DROPDOWN_DEFAULT_VALUE))
      setFilteredUseAndCareVideos(
        useAndCareVideosData.filter(
          (useAndCareVideo: UseAndCareVideosModel) =>
            useAndCareVideo.attributes.brand === brandFilter &&
            useAndCareVideo.attributes.category === categoryFilter
        )
      );
  }, [brandFilter, categoryFilter]);

  return {
    brandFilter,
    filteredDropdownOptions,
    filteredUseAndCareVideos,
    setBrandFilter,
    setCategoryFilter
  };
};
